export default __webpack_public_path__ + "static/media/LAS0840.34I-39021_-22873_0.161262ea.jpg";